// src/auth/permissionCodes.ts
export const PERMISSIONS = {
  ENTERPRISE_MANAGEMENT_VIEW: 'VW_ENT_MGMT',
  EDIT_ENTERPRISE: 'UPDT_ENT',
  ENTERPRISE_ONBOARDING_VIEW: 'VW_ENT_ONB',
  ASSET_IDENTITY_VAULT_VIEW: 'VW_IDV',
  ESIM_INVENTORY_VIEW: 'VW_ESIV',
  IDENTITIES_VIEW: 'VW_IDSV',
  SMS_VIEW: 'VW_SMSV',
  SUSPEND_TERMINATE_VIEW: 'VW_SUS_RES',
  ENV_TOGGLE: 'VW_ENV_TOGGLE',
  ADMIN_CENTER_VIEW: 'VW_ADM_CNTR',
  ANALYTICS_VIEW: '',
  MNO_VIEW: '',
  ADMIN_CENTER: 'VW_ADM_CNTR',

  USER_MANAGEMENT_VIEW: 'VW_USR_MGMT',

  ROLE_MANAGEMENT_VIEW: 'VW_RL_MGMT',
  ROLE_MANAGEMENT_CREATE: 'CRT_RL',
  ROLE_MANAGEMENT_UPDATE: 'UPDT_RL',
  ROLE_MANAGEMENT_DELETE: 'DEL_RL',

  PERMISSION_MANAGEMENT_VIEW: 'VW_PRMN_MGMT',
  PERMISSION_MANAGEMENT_CREATE: 'CR_PERM',
  PERMISSION_MANAGEMENT_UPDATE: 'UPDT_PERM',
  PERMISSION_MANAGEMENT_DELETE: 'DEL_PERM',

  API_KEY_MANAGEMENT_VIEW: 'VW_API_KEY_MGMT',

  EEU_ENTERPRISE_LIST: 'VW_EEU_ENT_LIST',
  ASSET_ALLOCATION_VIEW: 'VW_ASSET_ALLOC',

  ONBOARDING_STATUS_VIEW: 'VW_ONB_STATUS',
  APPLET_ACTIONS_MANAGE: 'MNG_APLT_ACT',
  VIEW_TERMINATE: 'VW_TERMINATE',
  PROVISION_BTN: 'VW_PROVSN_BTN',
} as const;

export type PermissionCode = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
